import {
    clearError,
    departementChangeHandler,
    displayError,
    displaySuggestions,
    // loadCommunes,
    searchAddress
} from "./AdressSearch.ts";

export function InitChampAdress(id_input_address){
    const switchHorsFrance = document.getElementById('id_hors_france_b');
    const addressFranceInput = document.getElementById(id_input_address);
    const addressHorsFranceInput = document.getElementById('id_address_hors_france');
    const departementInput = document.getElementById('id_departement');
    const communeInput = document.getElementById('id_commune');
    const franceFields = document.getElementById('champs_france_address');
    const foreignAddress = document.getElementById('champs_hors_france_address');
    const instanceAdministration = document.getElementById('id_instance_administration');

    switchHorsFrance?.addEventListener('change', toggleAddressFields);
    departementInput?.addEventListener('change', departementChangeHandler);

    const inputAddress = document.getElementById(id_input_address);

    inputAddress?.addEventListener('input', async (event) => {
        const query = (event.target as HTMLInputElement).value;
        if (query.length < 3) {
            // Ne pas lancer la recherche si la saisie est inférieure à 3 caractères
            document.getElementById('suggestions')!.innerHTML = '';
            return;
        }
        clearError();
        try {
            const results = await searchAddress(query);
            displaySuggestions(results, id_input_address, "id_commune", "id_departement");
        } catch (error) {
            displayError("Impossible de récupérer les suggestions. Veuillez réessayer.");
        }
    });


    // Fermer les suggestions lorsqu'on clique en dehors
    document.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        if (!target.closest('.input-wrapper')) {
            const suggestionsContainer = document.getElementById('suggestions');
            if (suggestionsContainer) {
                suggestionsContainer.innerHTML = '';
            }
        }
    });

    // Toggle les champs adreses lorsqu'on se situe hors de france
    function toggleAddressFields() {
        if (switchHorsFrance.checked) {
            franceFields.classList.add('d-none');
            foreignAddress.classList.remove('d-none');

            // Désactiver les champs adresse française et activer le champ "Adresse à l'étranger"
            addressFranceInput.required = false;
            departementInput.required = false;
            communeInput.required = false;
            addressHorsFranceInput.required = true;
            instanceAdministration.required = true;

            addressFranceInput.disabled = true;
            departementInput.disabled = true;
            communeInput.disabled = true;
            addressHorsFranceInput.disabled = false;
            instanceAdministration.disabled = false;
        } else {
            franceFields.classList.remove('d-none');
            foreignAddress.classList.add('d-none');

            // Activer les champs adresse française et désactiver le champ "Adresse à l'étranger"
            addressFranceInput.required = true;
            departementInput.required = true;
            communeInput.required = true;
            addressHorsFranceInput.required = false;
            instanceAdministration.required = false;

            addressFranceInput.disabled = false;
            departementInput.disabled = false;
            communeInput.disabled = false;
            addressHorsFranceInput.disabled = true;
            instanceAdministration.disabled = true;
        }
    }
    toggleAddressFields();
}
